import styled, {css} from "styled-components";
const SectionProductos = styled.section `
    margin-top: 60px;
    min-height: 80vh;
    h1 {
        text-align: center;
    }
    a {
        background-color: #00054C;
        color: #fff;
        text-decoration: none;
    }
    
   
`
export default SectionProductos